// const BASE_URL = "http://localhost:8080";

const BASE_URL = 'https://rkcon.in';

export { BASE_URL };
